export { default } from './ModalAccountLinking';
